import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Dialog } from '@mui/material';
import { IProps, IStateProps, IDispatchProps } from './interfaces';
import UpdateGameSchedule from './UpdateGameSchedule/component';
import { IAppState } from '../../../state/reducers';
import { clearAll } from '../../../state/exchange/updateGameScheduleDialog';

class UpdateGameScheduleDialog extends PureComponent<IProps> {
  render() {
    const {
      isOpen,
      isUpdating,
      onClose,
    } = this.props;

    return (
      <Dialog
        open={isOpen}
        onClose={() => { if (!isUpdating) onClose(); }}
        fullWidth
        maxWidth="md"
        className="UpdateGameScheduleDialog"
      >
        <UpdateGameSchedule />
      </Dialog>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  isOpen: state.exchange.updateGameScheduleDialog.isOpen,
  isUpdating: state.exchange.updateGameScheduleDialog.isUpdating,
});

const mapDispatchToProps: IDispatchProps = {
  onClose: clearAll,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UpdateGameScheduleDialog);
